<template>
    <div>
        <Banner :banners="banners" show-overlay> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper default">
            <h2 class="title text-center">解說牌</h2>
            <div class="search-wrapper mb-3">
                <div class="d-flex">
                    <div class="input-group mr-1">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="請輸入關鍵字"
                        />
                        <div class="input-group-append">
                            <button class="btn btn-search">
                                <img
                                    src="@/assets/common_ic_enter_search.png"
                                    alt=""
                                />
                            </button>
                        </div>
                    </div>
                    <button
                        class="btn btn-filter"
                        @click="searchFilterShow = !searchFilterShow"
                    >
                        <img src="@/assets/common_ic_enter_filter.png" alt="" />
                    </button>
                </div>
                <div class="search-filter" v-show="searchFilterShow">
                    <ul class="row form-row m-0">
                        <li class="col-4">
                            <div class="item">柳川步道解說牌</div>
                        </li>
                        <li class="col-4"><div class="item">景點</div></li>
                        <li class="col-4"><div class="item">美食</div></li>
                    </ul>
                </div>
            </div>
            <div class="result-total-text">共有55項結果</div>
            <ul class="px-1 py-2">
                <li v-for="i in 5" :key="i">
                    <a href="" @click.prevent="goDetail('雨水花園')">
                        <div class="list-card green">
                            <div class="img-wrapper">
                                <img src="@/assets/banner_guide.jpg" alt="" />
                            </div>
                            <div class="card-body">
                                <div class="title">雨水花園</div>
                                <div class="distance">
                                    <img
                                        src="@/assets/self_ic_map.png"
                                        alt="距離"
                                    />30m
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/instruction_img.jpg'),
                },
            ],
            searchFilterShow: false,
        };
    },
    methods: {
        goDetail(id) {
            this.$router.push(`${this.$route.path}/${id}`);
        },
    },
    components: {
        Banner,
        Breadcrumb,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
